import {
	API_GET_ALL_EMERGENCY_REASON,
	API_ADMIN_GET_ALL_EMERGENCY_REASON,
	API_ADMIN_GET_EMERGENCY_REASON,
	ADMIN_INIT_NEW_EMERGENCY_REASON,
	ADMIN_RESET_FOCUS_EMERGENCY_REASON,
	API_ADMIN_POST_EMERGENCY_REASON,
	API_ADMIN_PATCH_EMERGENCY_REASON,
	API_ADMIN_DELETE_EMERGENCY_REASON,
} from 'actions/emergencyReason';

export function getAllEmergencyReasons() {
	return {
		type: API_GET_ALL_EMERGENCY_REASON,
		payload: {
			request: {
				url: `/emergencyReasons`
			}
		}
	};
}

export function adminGetAllEmergencyReasons() {
	return {
		type: API_ADMIN_GET_ALL_EMERGENCY_REASON,
		payload: {
			request: {
				url: `/admin/emergencyReasons`
			}
		}
	};
}

export function adminGetEmergencyReason(emergencyReason) {
	return {
		type: API_ADMIN_GET_EMERGENCY_REASON,
		payload: {
			request: {
				url: `/admin/emergencyReasons/${emergencyReason.id}`
			}
		}
	};
}

export function adminPostEmergencyReason(emergencyReason) {
	return {
		type: API_ADMIN_POST_EMERGENCY_REASON,
		payload: {
			request: {
				url: `/admin/emergencyReasons`,
				method: 'POST',
				data: emergencyReason
			}
		}
	};
}

export function adminPatchEmergencyReason(emergencyReason) {
	return {
		type: API_ADMIN_PATCH_EMERGENCY_REASON,
		payload: {
			request: {
				url: `/admin/emergencyReasons/${emergencyReason.id}`,
				method: 'PATCH',
				data: emergencyReason
			}
		}
	};
}

export function adminDeleteEmergencyReason(emergencyReason) {
	return {
		type: API_ADMIN_DELETE_EMERGENCY_REASON,
		payload: {
			request: {
				url: `/admin/emergencyReasons/${emergencyReason.id}`,
				method: 'DELETE'
			}
		}
	};
}

export function initNewEmergencyReason() {
	return {
		type: ADMIN_INIT_NEW_EMERGENCY_REASON
	};
}

export function resetFocusEmergencyReason() {
	return {
		type: ADMIN_RESET_FOCUS_EMERGENCY_REASON
	};
}
